import { Currency } from '@/core/currency/interfaces';

const XPF: Currency = {
    name: 'CFP Franc (Franc Pacifique)',
    demonym: 'CFP',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '953',
    symbol: '₣',
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'XPF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default XPF;
